import React from 'react'
import '../print.scss';

type Props = {
    children:any
}

const ControllerHeader = ({children}: Props) => {

  return ( 
  <div className='controller_container no-print'>
    {/* Các thành phần không in ra thì sẽ gắn class = 'no-print' */}
    {children}
  </div>
  )
}

export default ControllerHeader